/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MoveAbility = {
    type: 'string',
} as const;
